import { CallbackProperty, Cartesian3 } from "cesium";
import { getElevatedCesiumPoint } from "../utils/get-elevated-cesium-point";

/* eslint-disable no-underscore-dangle */

export interface CesiumPolygonHierarchy {
    positions: Cartesian3[];
    holes?: CesiumPolygonHierarchy[];
}

export class PolylineWithHeight {
    public positions: Cartesian3[] = [];
    private _elevatedPositions: Cartesian3[] | undefined;
    private _maxHeights: number[] = [];
    private _minHeights: number[] = [];

    public addPoint(position: Cartesian3, maxHeight: number, minHeight: number) {
        this.positions.push(position);
        this._maxHeights.push(maxHeight);
        this._minHeights.push(minHeight);
        this._elevatedPositions = this.positions.map((pos, index) => getElevatedCesiumPoint(pos, this._maxHeights[index]));
    }

    public positionCallbackProperty() {
        return new CallbackProperty(() => this.positions, false);
    }

    public maxHeights() {
        return new CallbackProperty(() => this._maxHeights, false);
    }

    public minHeights() {
        return new CallbackProperty(() => this._minHeights, false);
    }

    public clear() {
        this.positions = [];
        this._maxHeights = [];
        this._minHeights = [];
    }

    public getMaxElevatedPositionsCallbackProperty(isStatic = false) {
        return new CallbackProperty(() => this._elevatedPositions, isStatic);
    }
}
